export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Název:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložit"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zpět"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte prosím nový název pro aktivum"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tento název vám pomůže snáze identifikovat peněženku v seznamu aktiv."])}
}